import { ListItem, ListItemText, useTheme } from '@mui/material';
import { NavLink } from 'react-router-dom';

interface SidebarItemProps {
  to: string;
  icon?: JSX.Element;
  label: React.ReactNode;
  type?: string;
  disabled?: boolean;
  end?: boolean;
  isHovered?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export default function SidebarItem({
  to,
  icon,
  label,
  type,
  disabled = false,
  end = false,
  isHovered = true,
  onClick
}: SidebarItemProps) {
  const theme = useTheme();
  return (
    <>
      {type !== 'mobile' ? (
        <ListItem>
          <NavLink
            to={disabled ? '#' : to}
            end={end}
            onClick={onClick}
            style={({ isActive }) => ({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: isHovered ? '1px 10px' : '10px 8px',
              gap: isHovered ? '18px' : '0px',
              textDecoration: 'none',
              borderRadius: '4px',
              color: disabled ? '#aaa' : '#242424',
              backgroundColor: disabled ? 'transparent' : isActive ? theme.palette.primary.light : 'transparent',
              fontWeight: isActive ? 'bold' : 'normal',
              width: '100%',
              pointerEvents: disabled ? 'none' : 'auto',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            })}
          >
            {icon}
            {isHovered && <ListItemText primary={label} sx={{ textWrap: 'nowrap' }} />}
          </NavLink>
          {/* {disabled && (
            <Typography variant='caption' color='textSecondary' sx={{ fontSize: '0.5rem', whiteSpace: 'nowrap' }}>
              Coming soon
            </Typography>
          )} */}
        </ListItem>
      ) : (
        <ListItem className='mobile-sidebar'>
          <NavLink
            to={disabled ? '#' : to}
            end={end}
            onClick={onClick}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              padding: '2px 20px',
              gap: '4px',
              textDecoration: 'none',
              borderRadius: type === 'mobile' ? '5px' : '100px',
              color: disabled ? '#aaa' : isActive ? '#fff' : '#777777',
              backgroundColor: disabled ? '#E0E0E0' : isActive ? theme.palette.primary.main : '',
              // border: !isActive && !disabled ? '1px solid #777' : '',
              pointerEvents: disabled ? 'none' : 'auto',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            })}
          >
            {icon}
            <ListItemText primary={label} sx={{ textWrap: 'nowrap' }} />
          </NavLink>
        </ListItem>
      )}
    </>
  );
}
